import * as React from "react";
import { Button, Divider, AppBar as MuiAppbar, Box, Typography, ClickAwayListener, Drawer } from "@mui/material";
import { useSlideInContext } from "ui";
import { SELECT_LOCATION } from "ft-shared-components";
// import { SELECT_TOUR_STEP, USER_GUIDES } from "../SlideIn";
// import { useSlideInContext } from "../../../context/SlideInContext";
// import { SELECT_LOCATION, USER_GUIDES } from "../SlideIn/contentTypes";
// import usePersonStore, { LocationModel } from "../../store/personStore";
import usePersonAuthStore from "../../store/personAuthStore";
import { useNavigate } from "react-router";
import { Help, Insights, People, Person, Work, Business } from "@mui/icons-material";
import { useMainMenuContext } from "./MainMenuProvider";
import {
    USER_ROLE_EDUCATION_STANDARD, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_SUPER, USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_SUPPORT_ADMIN,
    allHaveAccess,
    canViewInsights,
    canViewStaff,
} from "ft-shared-graphql";

// function LocationMenuItem({
//     location,
//     display,
//     onClick,
// }: {
//     location: LocationModel | null;
//     display: boolean;
//     onClick: () => void;
// }) {
//     if (!display) return null;

//     return (
//         <>
//             <Box
//                 data-tour="change-location"
//                 sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 1,
//                     padding: 1
//                 }} >
//                 <Business sx={{ color: "#fff" }} fontSize="large" />
//                 <Box sx={{ display: "flex", flexDirection: "column" }}>
//                     <Typography sx={{ color: "#fff" }}>  {location?.name}</Typography>
//                     <Button size="small" variant="outlined" sx={{ color: "#fff", width: "50%", border: "solid 2px" }} onClick={onClick}>
//                         Change
//                     </Button>
//                 </Box>
//             </Box>
//         </>
//     );
// }

export default function MainMenu() {
    const navigate = useNavigate();
    const { openMenu, toggleMenu, activeItem, handleSelection } = useMainMenuContext();
    const { handleContent } = useSlideInContext();
    // const defaultLocation = usePersonStore(
    //     (state) => state.company.defaultLocation
    // );
    // const setDefaultLocation = usePersonStore((state) => state.setDefaultLocation)
    // const locations = usePersonStore((state) => state.locations)
    const roles = usePersonAuthStore((state) => state.roles);
    // const handleLocationChangeClick = () => {
    //     handleContent(SELECT_LOCATION, {
    //         _locations: locations,
    //         setDefaultLocation: setDefaultLocation,
    //         defaultLocation: defaultLocation
    //     });
    // };

    const menuItems = [
        {
            label: "Staff",
            dataTour: "manage-staff-link",
            requiredRole: canViewStaff,
            icon: <People />,
            onClick: () => {
                handleSelection("STAFF")
                navigate("/manage/users");
            },
        },
        {
            label: "Company",
            dataTour: "company-information",
            requiredRole: canViewInsights,
            icon: <Work />,
            onClick: () => {
                handleSelection("COMPANY")
                navigate("/manage/company")
            }
        },
        {
            label: "Insights",
            dataTour: "student-insights",
            requiredRole: canViewInsights,
            icon: <Insights sx={{ border: "white solid 2px", borderRadius: "2px" }} />,
            onClick: () => {
                handleSelection("INSIGHTS")
                navigate("/manage/company/students")
            }
        },
        {
            label: "User Guides",
            dataTour: "user-guides",
            requiredRole: allHaveAccess,
            icon: <Help />,
            onClick: () => {
                // handleContent(USER_GUIDES)
            }
        },
        {
            label: "Guided Tutorials",
            dataTour: "guided-tutorials",
            requiredRole: allHaveAccess,
            icon: <Help />,
            onClick: () => {
                // handleContent(SELECT_TOUR_STEP)
            }
        },

    ];
    const menuItemsFiltered = menuItems
        .filter((x: any) =>
            x.requiredRole ? x.requiredRole(roles) : true
        )
    const handleClose = toggleMenu;
    return (
        <ClickAwayListener onClickAway={toggleMenu}>
            <>
                {openMenu && (
                    <Box
                        onClick={() => toggleMenu()}
                        sx={{
                            position: "fixed",
                            top: 0,
                            left: "250px",
                            right: 0,
                            bottom: 0,
                            zIndex: theme => theme.zIndex.drawer - 1,
                        }}
                    />
                )}
                <Drawer anchor="left"
                    open={openMenu}
                    hideBackdrop
                    variant="persistent"
                    slotProps={{
                        paper: {
                            sx: {
                                borderRight: "none",
                                width: "250px",
                                backgroundColor: "secondary.main",
                                display: "flex",
                                flexDirection: "column", justifyContent: "space-between", height: "100%"
                            }
                        }
                    }}
                    onClose={handleClose}
                >
                    <Box>
                        <Button
                            sx={{ color: "#fff", textTransform: "none", fontWeight: "400", fontSize: "large" }}
                            startIcon={<Box
                                component="img"
                                sx={{
                                    marginTop: 1.3,
                                    marginBottom: 1.5,
                                    height: "45px",
                                    width: "45px",
                                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/logos/ft_logo_sm.jpg)`,
                                    backgroundSize: "cover",
                                    borderRadius: "15px",

                                }} />}
                            onClick={() => {
                                handleSelection(null)
                                navigate("/dashboard")
                            }}>
                            futuresTHRIVE
                        </Button>
                        <Box sx={{ paddingLeft: "10px", display: "flex", flexDirection: "column", alignItems: "self-start", textAlign: "start" }}>
                            {menuItemsFiltered.map((item, index) => (
                                <Button
                                    data-tour={item.dataTour}
                                    id={`${item.label}`}
                                    sx={{
                                        color: "#fff", fontSize: "medium",
                                        width: "95%",
                                        backgroundColor:
                                            activeItem?.toLowerCase().includes(item.label.toLowerCase())
                                                ? "rgba(255, 255, 255, 0.25)"
                                                : "transparent",
                                        justifyContent: "start",
                                        "&:hover": {
                                            backgroundColor: "rgba(255, 255, 255, 0.25)",
                                        },
                                    }}
                                    onClick={item.onClick}
                                    startIcon={item.icon}>
                                    {item.label}
                                </Button>
                            ))}
                        </Box>
                    </Box>
                    <Box>
                        {/* <LocationMenuItem
                            display={(locations.length > 1)}
                            onClick={handleLocationChangeClick}
                            location={defaultLocation}
                        /> */}
                    </Box>
                </Drawer>
            </>
        </ClickAwayListener >

    );
}
